// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-dark {
  color: snow;
  padding:0rem 10rem 5rem 5rem;
  height: 100%;
}

.rc-modal-container {
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(15px);
          backdrop-filter: blur(15px);

  display: flex;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.rc-modal-content {
  background-color: #343a40;
  color: #fff;

  border-radius: 10px;
  padding: 1rem;
  width: 80%;
  min-height: 50%;
  max-height: 80%;

  overflow: auto;
}

.modal-dark .modal-content {
  background-color: #343a40;
  color: #fff;
}

.modal-header-dark {
  background-color: #343a40;
  border-bottom: 1px solid #454d55;
}

.modal-body-dark {
  background-color: #343a40;
}

.accordion-dark .accordion-header {
  background-color: #343a40;
  color: #fff;
}

.accordion-dark .accordion-body {
  background-color: #454d55;
  color: #fff;
}

.dark-select {
  background-color: #333333 !important;
  color: snow;
  border: 1px solid #454545;
  outline: none !important;
}

.dark-select > * {
  background-color: #333333 !important;
  color: snow !important;
  border: 1px solid #454545;
  outline: none !important;
}

.dark-select > * > *, .dark-select > * > * > *, .dark-select > * > * > * > * {
  background-color: #333333 !important;
  color: snow !important;
  outline: none !important;
}

.dark-select:focus, .dark-select:active, .dark-select:hover {
  background-color: #333333 !important;
  color: snow;
  border: 1px solid #454545;
  outline: none !important;
}

.image-select-portal {
  position: absolute !important;
  z-index: 9999 !important;
  top: 0 !important;
  display: hidden !important;
}

.card {
  color: snow !important;
  background-color: #333333 !important;
  border: 1px solid #444 !important;
}

.card-header {
  border: 1px solid #444 !important;
}

.card-subtitle {
  color: snow !important;
  margin-top: 0.5rem !important;
  margin-left: 1rem !important;
}

.list-group-item {
  background-color: #444 !important;
  color: snow !important;
  border: 1px solid #333 !important;
}

.session-modal {
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(15px);
          backdrop-filter: blur(15px);
}

.modal-dialog {
  width: 80% !important;
  margin: 0 auto !important;
}

.session-modal-large {
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(15px);
          backdrop-filter: blur(15px);
  min-width: 90%;
}

.session-modal-header {
  background-color: #333333;
  color: snow;
  border-bottom: 1px solid #454545;
}

.session-modal-body {
  background-color: #333333;
  color: snow;
}

.session-modal-footer {
  background-color: #333333;
  color: snow;
  border-top: 1px solid #454545;
}

.session-modal-weather-table-header,
.session-modal-weather-table-header > tr > th {
  background-color: #333333 !important;
  color: snow !important;
}

.snow {
  color: snow !important;
}

.modal-body > .row > .col > input {
  background-color: #333333;
  color: snow;
  border: 1px solid #666666 !important;
  outline: none !important;
}

.modal-body > .row > .col > input:focus, .modal-body > .row > .col > input:focus-visible, .modal-body > .row > .col > input:active, .modal-body > .row > .col > input:hover {
  background-color: #454545 !important;
  color: snow !important;
  border: 1px solid #454545 !important;
  outline: none !important;
}

.modal-body > .row > .col > select {
  background-color: #333333;
  color: snow;
  border: 1px solid #666666 !important;
  outline: none !important;
}

.modal-body > .row > .col > select:focus, .modal-body > .row > .col > select:focus-visible, .modal-body > .row > .col > select:active, .modal-body > .row > .col > select:hover {
  background-color: #454545 !important;
  color: snow !important;
  border: 1px solid #454545 !important;
  outline: none !important;
}

.dark-input {
  background-color: #333333;
  color: snow;
  border: 1px solid #454545;
  outline: none !important;
}

.dark-input:focus, .dark-input:focus-visible, .dark-input:active, .dark-input:hover {
  background-color: #454545 !important;
  color: snow !important;
  border: 1px solid #454545 !important;
  outline: none !important;
}

.dark-select {
  background-color: #333333;
  color: snow;
  border: 1px solid #454545;
  outline: none !important;
}


.logo {
  width: 25px;
  height: 25px;
  margin-right: 0.5rem;
  border-radius: 50%;
}

.flag {
  width: 25px;
  height: 25px;
  margin-right: 0.5rem;
}


.team-member {
  border-top: 1px solid #5e5d5d;
  padding: 1rem;
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.team-member > span { 
  width: 2rem;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.team-member > span.xsm {
  min-width: 1rem;
}

.team-member > span.sm {
  min-width: 2rem;
}

.team-member > span.md {
  min-width: 4rem;
}

.team-member > span.lg {
  min-width: 9rem;
}

.team-member > span.xlg {
  min-width: 12rem;
}

.team-member > span.xxlg {
  min-width: 16rem;
}

.team-member > span.xxxlg {
  min-width: 20rem;
}


`, "",{"version":3,"sources":["webpack://./src/css/dark-mode.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,mCAA2B;UAA3B,2BAA2B;;EAE3B,aAAa;EACb,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;;EAET,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;;EAEX,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,eAAe;EACf,eAAe;;EAEf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,mCAA2B;UAA3B,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,wBAAwB;AAC1B;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;;AAGA;EACE,6BAA6B;EAC7B,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".container-dark {\n  color: snow;\n  padding:0rem 10rem 5rem 5rem;\n  height: 100%;\n}\n\n.rc-modal-container {\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(15px);\n\n  display: flex;\n  position: fixed;\n  z-index: 9999;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n}\n\n.rc-modal-content {\n  background-color: #343a40;\n  color: #fff;\n\n  border-radius: 10px;\n  padding: 1rem;\n  width: 80%;\n  min-height: 50%;\n  max-height: 80%;\n\n  overflow: auto;\n}\n\n.modal-dark .modal-content {\n  background-color: #343a40;\n  color: #fff;\n}\n\n.modal-header-dark {\n  background-color: #343a40;\n  border-bottom: 1px solid #454d55;\n}\n\n.modal-body-dark {\n  background-color: #343a40;\n}\n\n.accordion-dark .accordion-header {\n  background-color: #343a40;\n  color: #fff;\n}\n\n.accordion-dark .accordion-body {\n  background-color: #454d55;\n  color: #fff;\n}\n\n.dark-select {\n  background-color: #333333 !important;\n  color: snow;\n  border: 1px solid #454545;\n  outline: none !important;\n}\n\n.dark-select > * {\n  background-color: #333333 !important;\n  color: snow !important;\n  border: 1px solid #454545;\n  outline: none !important;\n}\n\n.dark-select > * > *, .dark-select > * > * > *, .dark-select > * > * > * > * {\n  background-color: #333333 !important;\n  color: snow !important;\n  outline: none !important;\n}\n\n.dark-select:focus, .dark-select:active, .dark-select:hover {\n  background-color: #333333 !important;\n  color: snow;\n  border: 1px solid #454545;\n  outline: none !important;\n}\n\n.image-select-portal {\n  position: absolute !important;\n  z-index: 9999 !important;\n  top: 0 !important;\n  display: hidden !important;\n}\n\n.card {\n  color: snow !important;\n  background-color: #333333 !important;\n  border: 1px solid #444 !important;\n}\n\n.card-header {\n  border: 1px solid #444 !important;\n}\n\n.card-subtitle {\n  color: snow !important;\n  margin-top: 0.5rem !important;\n  margin-left: 1rem !important;\n}\n\n.list-group-item {\n  background-color: #444 !important;\n  color: snow !important;\n  border: 1px solid #333 !important;\n}\n\n.session-modal {\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(15px);\n}\n\n.modal-dialog {\n  width: 80% !important;\n  margin: 0 auto !important;\n}\n\n.session-modal-large {\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(15px);\n  min-width: 90%;\n}\n\n.session-modal-header {\n  background-color: #333333;\n  color: snow;\n  border-bottom: 1px solid #454545;\n}\n\n.session-modal-body {\n  background-color: #333333;\n  color: snow;\n}\n\n.session-modal-footer {\n  background-color: #333333;\n  color: snow;\n  border-top: 1px solid #454545;\n}\n\n.session-modal-weather-table-header,\n.session-modal-weather-table-header > tr > th {\n  background-color: #333333 !important;\n  color: snow !important;\n}\n\n.snow {\n  color: snow !important;\n}\n\n.modal-body > .row > .col > input {\n  background-color: #333333;\n  color: snow;\n  border: 1px solid #666666 !important;\n  outline: none !important;\n}\n\n.modal-body > .row > .col > input:focus, .modal-body > .row > .col > input:focus-visible, .modal-body > .row > .col > input:active, .modal-body > .row > .col > input:hover {\n  background-color: #454545 !important;\n  color: snow !important;\n  border: 1px solid #454545 !important;\n  outline: none !important;\n}\n\n.modal-body > .row > .col > select {\n  background-color: #333333;\n  color: snow;\n  border: 1px solid #666666 !important;\n  outline: none !important;\n}\n\n.modal-body > .row > .col > select:focus, .modal-body > .row > .col > select:focus-visible, .modal-body > .row > .col > select:active, .modal-body > .row > .col > select:hover {\n  background-color: #454545 !important;\n  color: snow !important;\n  border: 1px solid #454545 !important;\n  outline: none !important;\n}\n\n.dark-input {\n  background-color: #333333;\n  color: snow;\n  border: 1px solid #454545;\n  outline: none !important;\n}\n\n.dark-input:focus, .dark-input:focus-visible, .dark-input:active, .dark-input:hover {\n  background-color: #454545 !important;\n  color: snow !important;\n  border: 1px solid #454545 !important;\n  outline: none !important;\n}\n\n.dark-select {\n  background-color: #333333;\n  color: snow;\n  border: 1px solid #454545;\n  outline: none !important;\n}\n\n\n.logo {\n  width: 25px;\n  height: 25px;\n  margin-right: 0.5rem;\n  border-radius: 50%;\n}\n\n.flag {\n  width: 25px;\n  height: 25px;\n  margin-right: 0.5rem;\n}\n\n\n.team-member {\n  border-top: 1px solid #5e5d5d;\n  padding: 1rem;\n  margin-bottom: 0.5rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.team-member > span { \n  width: 2rem;\n  text-align: left;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.team-member > span.xsm {\n  min-width: 1rem;\n}\n\n.team-member > span.sm {\n  min-width: 2rem;\n}\n\n.team-member > span.md {\n  min-width: 4rem;\n}\n\n.team-member > span.lg {\n  min-width: 9rem;\n}\n\n.team-member > span.xlg {\n  min-width: 12rem;\n}\n\n.team-member > span.xxlg {\n  min-width: 16rem;\n}\n\n.team-member > span.xxxlg {\n  min-width: 20rem;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
